"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstitutableContainer = void 0;
// @ts-ignore
const constitute_1 = require("constitute");
const inversify_1 = require("inversify");
const getConstitutableMiddleware_1 = require("./getConstitutableMiddleware");
class ConstitutableContainer extends inversify_1.Container {
    constructor() {
        super({
            autoBindInjectable: true,
            skipBaseClassChecks: true,
            defaultScope: inversify_1.BindingScopeEnum.Singleton,
        });
        this.constituteContainer = new constitute_1.Container();
        constitute_1.Singleton.setCachedInstance(this.constituteContainer, ConstitutableContainer, this);
        this.applyMiddleware((0, getConstitutableMiddleware_1.getConstitutableMiddleware)(this));
    }
    bindValue(key, value) {
        return this.constituteContainer.bindValue(key, value);
    }
    get(serviceIdentifier) {
        return super.get(serviceIdentifier);
    }
    findBestFactory(key) {
        return this.constituteContainer.findBestFactory(key);
    }
    schedulePostConstructor(callback, constitutor = []) {
        return this.constituteContainer.schedulePostConstructor(callback, constitutor.map((dependency) => (this.isBound(dependency) ? new constitute_1.Value(this.get(dependency)) : dependency)));
    }
}
exports.ConstitutableContainer = ConstitutableContainer;
//# sourceMappingURL=ConstitutableContainer.js.map